import ServerTableController from "./server_table_base"

export default class extends ServerTableController {
  activeFilters = ""
  activeCategoryFilters = ""

  get filterWrapperName() { return "observations-filter" }
  get checkboxPrefix() { return "observations" }

  // Rows are rendered server-side (observations/_observation_row): [sort_date, filter_type, html].
  get columns() {
    return [
      { data: "0", visible: false },
      { data: "1", visible: false },
      { data: "2" }
    ]
  }

  applyFilters(detail) {
    this.activeFilters = detail.filters
    this.activeCategoryFilters = detail.categoryFilters || ""
  }

  ajaxData(d) {
    super.ajaxData(d)
    d.filters = this.activeFilters
    d.category_filters = this.activeCategoryFilters
    return d
  }

  createdRow(row, data, _dataIndex) {
    $(row)
      .addClass("item")
      .attr("data-observations-filter-target", "item")
      .attr("data-filter-type", data[1])
      .html(data[2])
  }
}
